import React from 'react';
import { MapPin, Phone, Mail } from 'lucide-react';

const Footer = () => {
  const primaryColor = "#232D3B";

  return (
    <footer id="contatti" className="bg-gray-900 text-white py-8">
      <div className="container mx-auto px-4">
        {/* Logo e informazioni essenziali */}
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-6 md:mb-0 text-center md:text-left">
            <h3 className="text-lg font-semibold mb-1">Mas Metal S.R.L.</h3>
            <p className="text-gray-400 text-xs">Commercio all'ingrosso di sottoprodotti metallici</p>
          </div>
          
          {/* Contatti essenziali */}
          <div className="flex flex-wrap justify-center md:justify-end gap-4 text-xs text-gray-300">
            <a href="https://maps.app.goo.gl/123" className="flex items-center hover:text-white">
              <MapPin size={14} className="mr-1" />
              <span>Via Padana Superiore 87/A, Castegnato (BS)</span>
            </a>
            <a href="tel:+390307998505" className="flex items-center hover:text-white">
              <Phone size={14} className="mr-1" />
              <span>+39 0307998505</span>
            </a>
            <a href="mailto:info@masmetalsrl.com" className="flex items-center hover:text-white">
              <Mail size={14} className="mr-1" />
              <span>info@masmetalsrl.com</span>
            </a>
          </div>
        </div>
        
        {/* Privacy e Cookie Policy */}
        <div className="mt-6 text-center">
          <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-400">
            <a 
              href="https://www.termsfeed.com/live/e06f65ad-cdb5-40fe-b4e2-9fac99e5481f" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              Privacy Policy
            </a>
            <span>|</span>
            <a 
              href="https://www.termsfeed.com/live/9fafeb07-59ea-4afc-928f-905f1335a43a" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-white transition-colors"
            >
              Cookie Policy
            </a>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="border-t border-gray-800 mt-6 pt-6 text-center text-gray-500 text-xs">
          <p>&copy; {new Date().getFullYear()} Mas Metal S.R.L. Tutti i diritti riservati.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;